import { useCallback, useEffect, useState } from 'react'
import { useAuth } from '@/auth/AuthProvider'
import { orgName, useOrg } from '@/org/OrgProvider'
import { leaveYearStart } from '@/lib/format'

function prefersLight(): boolean {
  const stamped = document.documentElement.getAttribute('data-theme')
  if (stamped !== null) return stamped === 'light'
  return window.matchMedia('(prefers-color-scheme: light)').matches
}

export function TopBar({ children }: { children?: React.ReactNode }) {
  const { current } = useOrg()
  const { signOut } = useAuth()
  const [light, setLight] = useState(prefersLight)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', light ? 'light' : 'dark')
  }, [light])

  const toggle = useCallback(() => setLight((v) => !v), [])

  return (
    <header className="bar">
      <div>
        <h1>{orgName(current)}</h1>
        <div className="sub">
          Leave year starts{' '}
          {current.leaveYearStartMonth !== null && current.leaveYearStartDay !== null && (
            <>
              {leaveYearStart(current.leaveYearStartMonth, current.leaveYearStartDay)} &middot;{' '}
            </>
          )}
          {current.timezone !== null && <>{current.timezone} &middot; </>}
          <span className="mono">{current.code}</span>
        </div>
      </div>
      <div className="spacer" />
      {children}
      <button className="btn quiet sm" type="button" onClick={toggle}>
        {light ? 'Dark' : 'Light'}
      </button>
      <button className="btn quiet sm" type="button" onClick={() => void signOut()}>
        Sign out
      </button>
    </header>
  )
}
